import type { InvoiceDetailResponse, NexDetailLine } from '../../../types/invoice';
import { nexDetailLineToManualMatchPayload } from '../../../utils/nexLineDisplay';
import type { ManualMatchEntry } from '../../../types/invoice/nex';

/** Build `manualMatches` payload from reconciliation local NEX overrides (save + submit). */
export function buildManualMatchesFromOverrides(
    localOverrides: Record<number, NexDetailLine>,
    invoiceType: InvoiceDetailResponse['invoiceType'] | undefined,
): ManualMatchEntry[] {
    return Object.entries(localOverrides).map(([k, nexLine]) => ({
        partIndex: parseInt(k, 10),
        nexLine: nexDetailLineToManualMatchPayload(nexLine, invoiceType),
    }));
}

/** Coerce manual PO header picker state to API `manualPoHeaderOverrides` keys. */
export function buildManualPoHeaderOverridesFromSelections(
    manualPoHeaderSelections: Record<number, number>,
): Record<string, number> {
    const manualPoHeaderOverrides: Record<string, number> = {};
    for (const [k, v] of Object.entries(manualPoHeaderSelections ?? {})) {
        if (typeof v === 'number' && Number.isFinite(v)) {
            manualPoHeaderOverrides[String(k)] = v;
        }
    }
    return manualPoHeaderOverrides;
}
